export default function Usb() {
  return (
    <div
      className="ion-icon-usb"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<path d="M144,220C144,220,144.1,220.1,144,220L144,220z"/>
	<path d="M384,128.3c0-17.8-14.4-32.2-32.1-32.2c-17.7,0-32.1,14.4-32.1,32.1c0,12.1,6.7,22.7,16.6,28.2c1.3,1.5,2.2,4.5,2.2,6
		c0,0.1,0,0.2,0,0.4c-0.8,17.6-3.8,31.9-7.1,41.7c-4.3,12.6-38.2,39.6-51.5,42.2c-5.8,1.2-7.9-0.6-7.9-10.2c0,0,0-138.9,0-140.4
		s0.2-3.5,1.9-5c0,0,0,0,0,0c8.6-5.8,14.3-15.6,14.3-26.8c0-17.8-14.4-32.2-32.1-32.2c-17.7,0-32.1,14.4-32.1,32.2
		c0,11.3,5.8,21.3,14.6,27c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.1,0.4,0.2c0.2,0.1,0.4,0.2,0.6,0.4c2.3,1.5,3.3,3,3.3,4.2
		c0,1.3,0,189.3,0,196.3s-1.1,12.3-8.4,11.8s-41.7-23.5-51.4-44.1c-4.5-9.5-6.8-18.8-6.8-28h0c0,0,0-0.4,0-0.5
		c0-3.1,0-11.3,3.2-13.6c7.8-5.9,12.8-15.2,12.8-25.7c0-17.8-14.4-32.2-32.1-32.2S128,174.4,128,192.2c0,11.9,6.5,22.3,16,27.8
		c2.4,1.5,3,2.9,3.8,10.6s3,24.6,9.1,39.9c7.3,18.6,20.9,32.6,39.7,45.2c13.6,9.3,25.3,16.6,32.1,26.4s10.2,13.5,10.2,27
		c0,0,0-0.9,0,0c0,12.8-4,14-9.3,17.8c-14.1,8.7-23.5,24.2-23.5,42c0,0.1,0,0.3,0,0.4c0,0.2,0,0.5,0,0.7c0,27.5,22.3,49.8,49.8,49.8
		c27.5,0,49.8-22.3,49.8-49.8c0-13.3-5.2-25.4-13.7-34.3c-2.9-3.2-6-6-9.6-8.3c-7.5-5.2-10.3-11.5-10.3-18.1v-24.1
		c0-25.1,4.1-41.1,11.1-53.3c7.3-12.7,18.3-22.6,35.4-34.2c18.8-12.6,32.2-26.6,39.6-45.2c5.7-14.4,7.6-31,8.6-50.9
		c0.1-1.8,1.4-5.8,3.3-6.8h0C378.4,149,384,139.3,384,128.3z M160.1,208.3c-8.9,0-16.1-7.3-16.1-16.2s7.2-16.2,16.1-16.2
		s16.1,7.3,16.1,16.2S169,208.3,160.1,208.3z M256,80.3c-8.9,0-16.1-7.3-16.1-16.2S247.1,48,256,48s16.1,7.3,16.1,16.2
		S264.9,80.3,256,80.3z M351.9,144.3c-8.9,0-16.1-7.3-16.1-16.2S343,112,351.9,112s16.1,7.3,16.1,16.2S360.8,144.3,351.9,144.3z"/>
</g>
</svg>
`,
      }}
    />
  )
}
